module.exports = __webpack_public_path__ + "static/media/honeycomb-3143432_1920.0d0d54ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/500/honeycomb-3143432_1920.jpg
// module id = 995
// module chunks = 0